module.exports = window.ReactDOM || window.require && window.require('reactDOM');